import React, { memo } from "react";

const loaderWrapperStyle = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(255,255,255,0.7)',
  zIndex: 2000,
  position: 'fixed',
  top: 0,
  left: 0,
};

const spinnerStyle = {
  width: 48,
  height: 48,
  border: '6px solid #e0e0e0',
  borderTop: '6px solid var(--bs-primary)',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const DefaultLoader = memo(() => (
  <div style={loaderWrapperStyle}>
    <div style={spinnerStyle} />
    <style>{`@keyframes spin {0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
  </div>
));

DefaultLoader.displayName = "DefaultLoader";
export default DefaultLoader;
